import PageHeader from "@/components/site/PageHeader";
import AboutSection from "@/components/sections/AboutSection";
import TeamCarousel from "@/components/sections/TeamCarousel";
import ContactForm from "@/components/sections/ContactForm";
import { motion } from "framer-motion";
import { HeartHandshake, Scale, Sparkles, Shield } from "lucide-react";
import { useI18n } from "@/i18n/i18n";

const ICONS = [HeartHandshake, Scale, Sparkles, Shield];

export default function About() {
  const { tr } = useI18n();
  return (
    <div data-testid="about-page">
      <PageHeader
        overline={tr.about_page.overline}
        title={tr.about_page.title}
        subtitle={tr.about_page.subtitle}
      />

      <AboutSection />
      <TeamCarousel />

      <section className="py-24 lg:py-32">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="max-w-2xl mb-14">
            <p className="overline text-[color:var(--mc-gold)]">{tr.about_page.values_overline}</p>
            <h2 className="font-serif-display text-4xl sm:text-5xl font-semibold tracking-tight mt-4 leading-tight text-white">
              {tr.about_page.values_title}
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {tr.about_page.values.map((v, i) => {
              const Icon = ICONS[i] || HeartHandshake;
              return (
                <motion.div
                  key={v.title}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.08 }}
                  className="mc-card p-8"
                  data-testid={`value-card-${i}`}
                >
                  <Icon className="h-8 w-8 text-[color:var(--mc-cyan)]" />
                  <p className="font-heading text-xl font-semibold mt-5 text-white">{v.title}</p>
                  <p className="mt-3 text-sm text-white/70 leading-relaxed">{v.desc}</p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>

      <ContactForm />
    </div>
  );
}
